import { createFileRoute } from '@tanstack/react-router'
import { ProductPageView } from '@src/components/ProductPageView'
import { useFormSettings } from '@src/components/LeadForm/useFormSettings'
import { loadProductPage } from '@src/utils/loadProductPage'
import { routePageHead } from '@src/utils/routeHead'
import type { TechnologyPageData } from '@src/types/strapi'

/** Campaign copy of a product page, stored in the CMS under the slug product/campaign. */
export const Route = createFileRoute('/products/$slug_/$campaign')({
  loader: ({ params }) => loadProductPage(`${params.slug}/${params.campaign}`),
  staleTime: 60_000,
  head: ({ loaderData }) =>
    routePageHead(
      loaderData?.pageData?.seo?.pageTitle,
      loaderData?.pageData?.seo?.noIndex,
    ),
  component: CampaignProductPage,
})

function CampaignProductPage() {
  const formSettings = useFormSettings()
  const { slug } = Route.useParams()
  const { pageData } = Route.useLoaderData() as {
    pageData: TechnologyPageData
  }

  return (
    <ProductPageView
      pageData={pageData}
      defaultLeadForm={formSettings?.productEnquiry}
      parentProductSlug={slug}
    />
  )
}
